const isLocalhost = (): boolean => {
  const hostname = window.location.hostname;
  return hostname === 'localhost' || hostname === '127.0.0.1';
};

const multiPartTLDs = [
  'com.br', 'net.br', 'org.br', 'gov.br', 'edu.br', 'mil.br',
  'co.uk', 'ac.uk', 'gov.uk', 'org.uk', 'net.uk',
  'co.jp', 'ac.jp', 'go.jp', 'or.jp', 'ne.jp',
  'com.au', 'net.au', 'org.au', 'edu.au', 'gov.au',
  'co.za', 'org.za', 'net.za', 'gov.za', 'ac.za',
  'com.ar', 'gov.ar', 'org.ar', 'net.ar', 'edu.ar',
  'co.nz', 'net.nz', 'org.nz', 'govt.nz', 'ac.nz',
  'com.mx', 'org.mx', 'net.mx', 'edu.mx', 'gob.mx',
  'co.in', 'net.in', 'org.in', 'edu.in', 'gov.in',
];

/**
 * Subdomínios conhecidos como prefixo do frontend/admin.
 * Estes são removidos ao construir URLs de serviços (backend, gateway).
 * Qualquer outro subdomínio (test, staging, etc.) é preservado como parte do domínio.
 */
const FRONTEND_SUBDOMAINS = ['v3', 'app', 'www', 'admin'];

/**
 * Retorna o domínio para serviços (backend, gateway, widget).
 * Remove apenas subdomínios de frontend conhecidos, preservando subdomínios de ambiente.
 */
const getServiceDomain = (): string => {
  const hostname = window.location.hostname;
  if (isLocalhost()) return hostname;

  const parts = hostname.split('.');

  const last2Parts = parts.slice(-2).join('.');
  const isMultiPartTLD = multiPartTLDs.includes(last2Parts);
  const minParts = isMultiPartTLD ? 3 : 2;

  if (parts.length > minParts && FRONTEND_SUBDOMAINS.includes(parts[0])) {
    return parts.slice(1).join('.');
  }

  return hostname;
};

export const getAdminApiBaseUrl = (): string => {
  if (import.meta.env.VITE_API_BASE_URL) return import.meta.env.VITE_API_BASE_URL;
  if (isLocalhost()) return 'http://localhost:3000/admin';
  return `https://backend.${getServiceDomain()}/admin`;
};

export const config = {
  apiBaseUrl: getAdminApiBaseUrl(),
  appName: import.meta.env.VITE_APP_NAME || 'Admin Panel',
  appVersion: import.meta.env.VITE_APP_VERSION || '1.0.0',
  nodeEnv: import.meta.env.VITE_NODE_ENV || 'development',
  isLocalhost: isLocalhost(),
};

export default config;
